export function StockRow({ stock }: any) {
  const up =
    stock.orderTrendChangeState === "up";

  return (
    <div className="flex justify-between border-b pb-2">

      <div>

        <div className="font-medium">
          {stock.symbol}
        </div>

        <div className="text-xs text-gray-500">
          {stock.company}
        </div>

      </div>

      <div
        className={
          up
            ? "text-green-600"
            : "text-red-600"
        }
      >
        {stock.orderTrendChangePercent}%
      </div>

    </div>
  );
}